<nav id="m_ver_menu" class="{{ui.getSideBarMenuClass()}}" data-menu-vertical="true"
    [attr.data-menu-dropdown]="ui.getIsMenuDropdown()" [attr.data-menu-scrollable]="ui.getIsMenuScrollable()"
    data-menu-dropdown-timeout="500" [attr.aria-label]="l('LeftMenu')">
    <!-- <ul *ngIf="isAdminUser" class="m-menu__nav {{ui.getMenuListClass()}}" role="menubar" [attr.aria-label]="l('LeftMenu')">
    </ul> -->
    <ul class="m-menu__nav {{ui.getMenuListClass()}} custom-sidebar" role="menubar" [attr.aria-label]="l('LeftMenu')">

        <li routerLinkActive="m-menu__item--active" [routerLinkActiveOptions]="{exact: true}"
            class="m-menu__item m-menu__item--submenu" aria-haspopup="true" data-menu-submenu-toggle="hover">

            <a [routerLink]="'/app/main/projects'" class="m-menu__link m-menu__toggle" role="menuitem"
                usetiful_id="sidebar__allProjects-button--primary" aria-haspopup="true" aria-expanded="false"
                [attr.tabindex]="0">
                <i class="m-menu__link-icon flaticon-squares-3"></i>
                <span class="m-menu__link-text">
                    <span class="title">All Projects</span>
                </span>
            </a>
        </li>
        <li routerLinkActive="m-menu__item--active" [routerLinkActiveOptions]="{exact: true}"
            usetiful_id="sidebar__newCalculation-panel--primary"
            class="m-menu__item m-menu__item--submenu m-menu__item--expanded m-menu__item--open" aria-haspopup="true"
            data-menu-submenu-toggle="hover">



            <a href="javascript:;" class="m-menu__link m-menu__toggle" role="menuitem" aria-haspopup="true"
                usetiful_id="sidebar__newCalculation-toggle--primary" aria-expanded="false" [attr.tabindex]="0">
                <i class="m-menu__link-icon fa fa-plus-square"></i>
                <span class="m-menu__link-text">
                    <span class="title">New Calculation</span>
                </span>
                <i class="m-menu__ver-arrow la la-angle-right"></i>
            </a>
            <nav class="m-menu__submenu new-calc-submenu" [attr.aria-label]="'New Calculation'">
                <span class="m-menu__arrow"></span>
                <div *ngIf="isCreatingCalculation" class="new-calc-loading-overlay">
                    <span class="new-calc-spinner"></span>
                </div>
                <ul class="m-menu__subnav" [attr.aria-label]="'New Calculation'" role="menu">
                    <li class="m-menu__item m-menu__item--submenu" aria-haspopup="true" data-menu-submenu-toggle="hover"
                        role="none" usetiful_id="sidebar-newCalculation__cableSizing-button--primary">
                        <a href="javascript:;" class="m-menu__link m-menu__toggle" role="menuitem" aria-haspopup="true"
                            aria-expanded="false" tabindex="-1" (click)="addNewCalculation(1)">
                            <i class="m-menu__link-icon">
                                <img class="" src="assets/cablepro/img/calc.jpg" style="width: 50%;">
                            </i>
                            <span class="m-menu__link-text">
                                <span class="title">Cable Sizing</span>
                            </span>
                            <i class="m-menu__ver-arrow fa fa-plus"></i>
                        </a>
                    </li>
                    <li class="m-menu__item m-menu__item--submenu" aria-haspopup="true" data-menu-submenu-toggle="hover"
                        role="none" usetiful_id="sidebar-newCalculation__maximumDemand-button--primary">
                        <a href="javascript:;" class="m-menu__link m-menu__toggle" role="menuitem" aria-haspopup="true"
                            aria-expanded="false" tabindex="-1" (click)="addNewCalculation(4)">
                            <i class="m-menu__link-icon">
                                <img class="" src="assets/cablepro/img/maxd.jpg" style="width: 50%;">
                            </i>
                            <span class="m-menu__link-text">
                                <span class="title">Maximum Demand</span>
                            </span>
                            <i class="m-menu__ver-arrow fa fa-plus"></i>
                        </a>
                    </li>
                    <li class="m-menu__item m-menu__item--submenu" aria-haspopup="true" data-menu-submenu-toggle="hover"
                        role="none">
                        <a href="javascript:;" class="m-menu__link m-menu__toggle" role="menuitem" aria-haspopup="true"
                            aria-expanded="false" tabindex="-1" (click)="addNewCalculation(6)">
                            <i class="m-menu__link-icon">
                                <img class="" src="assets/cablepro/img/Cable Pulling (75 x 75).png" style="width: 50%;">
                            </i>
                            <span class="m-menu__link-text">
                                <span class="title">Cable Pulling</span>
                            </span>
                            <i class="m-menu__ver-arrow fa fa-plus"></i>
                        </a>
                    </li>
                    <li class="m-menu__item m-menu__item--submenu" aria-haspopup="true" data-menu-submenu-toggle="hover"
                        role="none">
                        <a href="javascript:;" class="m-menu__link m-menu__toggle" role="menuitem" aria-haspopup="true"
                            usetiful_id="sidebar-newCalculation__LVNetwork-button--primary" aria-expanded="false"
                            tabindex="-1" (click)="addNewCalculation(7)">
                            <i class="m-menu__link-icon">
                                <img class="" src="assets/cablepro/img/network.png" style="width: 50%;">
                            </i>
                            <span class="m-menu__link-text">
                                <span class="title">LV Network</span>
                            </span>
                            <i class="m-menu__ver-arrow fa fa-plus"></i>
                        </a>
                    </li>
                    <li class="m-menu__item m-menu__item--submenu" aria-haspopup="true" data-menu-submenu-toggle="hover"
                        role="none">
                        <a href="javascript:;" class="m-menu__link m-menu__toggle" role="menuitem" aria-haspopup="true"
                            aria-expanded="false" tabindex="-1" (click)="addNewCalculation(5)">
                            <i class="m-menu__link-icon">
                                <img class="" src="assets/cablepro/img/ProtectiveDeviceCoordination.png"
                                    style="width: 50%;">
                            </i>
                            <span class="m-menu__link-text">
                                <span class="title">Protection</span>
                            </span>
                            <i class="m-menu__ver-arrow fa fa-plus"></i>
                        </a>
                    </li>
                    <li class="m-menu__item m-menu__item--submenu" aria-haspopup="true" data-menu-submenu-toggle="hover"
                        role="none">
                        <a href="javascript:;" class="m-menu__link m-menu__toggle" role="menuitem" aria-haspopup="true"
                            aria-expanded="false" tabindex="-1" (click)="addNewCalculation(8)">
                            <i class="m-menu__link-icon">
                                <img class="" src="assets/cablepro/img/arcflash.png" style="width: 50%;">
                            </i>
                            <span class="m-menu__link-text">
                                <span class="title">AC/DC Arc Flash</span>
                            </span>
                            <i class="m-menu__ver-arrow fa fa-plus"></i>
                        </a>
                    </li>
                </ul>
            </nav>
        </li>
        <li class="m-menu__item m-menu__item--submenu m-menu__item--expanded m-menu__item--open" aria-haspopup="true"
            data-menu-submenu-toggle="hover" usetiful_id="sidebar__recentCalculation-toggle--primary">
            <a href="javascript:;" class="m-menu__link m-menu__toggle" role="menuitem" aria-haspopup="true"
                aria-expanded="false" [attr.tabindex]="0">
                <i class="m-menu__link-icon flaticon-interface-8"></i>
                <span class="m-menu__link-text">
                    <span class="title">Recent Calculations</span>
                </span>
                <i class="m-menu__ver-arrow la la-angle-right"></i>
            </a>
            <nav class="m-menu__submenu" [attr.aria-label]="'Recent Calculations'">
                <span class="m-menu__arrow"></span>
                <ul class="m-menu__subnav" [attr.aria-label]="'Recent Calculations'" role="menu">
                    <ng-container
                        *ngIf="recentCalculations$ | async as recentCalculations; else loadingForCalculations">
                        <li *ngFor="let calculation of recentCalculations.result"
                            class="m-menu__item m-menu__item--submenu" aria-haspopup="true"
                            [ngClass]="{'m-menu__item--active': checkActiveClass(calculation)}"
                            data-menu-submenu-toggle="hover" role="none">
                            <a href="javascript:;" (click)="OpenCalculation(calculation)"
                                class="m-menu__link m-menu__toggle" role="menuitem" aria-haspopup="true"
                                aria-expanded="false" tabindex="-1">
                                <span class="m-menu__link-text">
                                    <span class="title bullet">
                                        {{calculation.name}}
                                    </span>
                                </span>
                            </a>
                        </li>
                    </ng-container>
                    <ng-template #loadingForCalculations>
                        <li class="m-menu__item m-menu__item--submenu" aria-haspopup="true"
                            style="display: table;width: 100%;" data-menu-submenu-toggle="hover" role="none">
                            <a href="javascript:;" class="m-menu__link m-menu__toggle" role="menuitem"
                                aria-haspopup="true" aria-expanded="false" tabindex="-1">
                                <span class="m-menu__link-text">
                                    <span class="title">
                                        <ngx-skeleton-loader
                                            [theme]="{height: '10px', 'margin-bottom': '0'}"></ngx-skeleton-loader>
                                    </span>
                                </span>
                            </a>
                            <!-- <a href="javascript:;" class="m-menu__link m-menu__toggle" role="menuitem"
                                style="padding: 0;text-align: center;vertical-align: middle;display: table-cell;"
                                aria-haspopup="true" aria-expanded="false" tabindex="-1">
                                <i class="fa fa-spinner fa-spin" style="color: #545874;"></i>
                            </a> -->
                        </li>
                        <li class="m-menu__item m-menu__item--submenu" aria-haspopup="true"
                            style="display: table;width: 100%;" data-menu-submenu-toggle="hover" role="none">
                            <a href="javascript:;" class="m-menu__link m-menu__toggle" role="menuitem"
                                aria-haspopup="true" aria-expanded="false" tabindex="-1">
                                <span class="m-menu__link-text">
                                    <span class="title">
                                        <ngx-skeleton-loader
                                            [theme]="{height: '10px', 'margin-bottom': '0'}"></ngx-skeleton-loader>
                                    </span>
                                </span>
                            </a>
                        </li>
                        <li class="m-menu__item m-menu__item--submenu" aria-haspopup="true"
                            style="display: table;width: 100%;" data-menu-submenu-toggle="hover" role="none">
                            <a href="javascript:;" class="m-menu__link m-menu__toggle" role="menuitem"
                                aria-haspopup="true" aria-expanded="false" tabindex="-1">
                                <span class="m-menu__link-text">
                                    <span class="title">
                                        <ngx-skeleton-loader
                                            [theme]="{height: '10px', 'margin-bottom': '0'}"></ngx-skeleton-loader>
                                    </span>
                                </span>
                            </a>
                        </li>
                        <li class="m-menu__item m-menu__item--submenu" aria-haspopup="true"
                            style="display: table;width: 100%;" data-menu-submenu-toggle="hover" role="none">
                            <a href="javascript:;" class="m-menu__link m-menu__toggle" role="menuitem"
                                aria-haspopup="true" aria-expanded="false" tabindex="-1">
                                <span class="m-menu__link-text">
                                    <span class="title">
                                        <ngx-skeleton-loader
                                            [theme]="{height: '10px', 'margin-bottom': '0'}"></ngx-skeleton-loader>
                                    </span>
                                </span>
                            </a>
                        </li>
                    </ng-template>
                </ul>
            </nav>
        </li>
        <li class="m-menu__item m-menu__item--submenu m-menu__item--expanded m-menu__item--open" aria-haspopup="true"
            data-menu-submenu-toggle="hover">
            <a href="javascript:;" class="m-menu__link m-menu__toggle" role="menuitem" aria-haspopup="true"
                aria-expanded="false" [attr.tabindex]="0">
                <i class="m-menu__link-icon flaticon-interface-8"></i>
                <span class="m-menu__link-text">
                    <span class="title">Recent Projects</span>
                </span>
                <i class="m-menu__ver-arrow la la-angle-right"></i>
            </a>
            <nav class="m-menu__submenu" [attr.aria-label]="'Recent Projects'">
                <span class="m-menu__arrow"></span>
                <ul class="m-menu__subnav" [attr.aria-label]="'Recent Projects'" role="menu">
                    <ng-container *ngIf="recentProjects$ | async as recentProjects; else loadingForProjects">
                        <li *ngFor="let project of recentProjects.result" class="m-menu__item m-menu__item--submenu"
                            aria-haspopup="true" [ngClass]="{'m-menu__item--active': checkProjectActiveClass(project)}"
                            data-menu-submenu-toggle="hover" role="none">
                            <a href="javascript:;" (click)="OpenProject(project)" class="m-menu__link m-menu__toggle"
                                role="menuitem" aria-haspopup="true" aria-expanded="false" tabindex="-1">
                                <span class="m-menu__link-text">
                                    <span class="title bullet">
                                        {{project.name}}
                                    </span>
                                </span>
                            </a>
                        </li>
                    </ng-container>
                    <ng-template #loadingForProjects>
                        <!-- <li class="m-menu__item m-menu__item--submenu" aria-haspopup="true"
                            style="display: table;width: 100%;" data-menu-submenu-toggle="hover" role="none">
                            <a href="javascript:;" class="m-menu__link m-menu__toggle" role="menuitem"
                                style="padding: 0;text-align: center;vertical-align: middle;display: table-cell;"
                                aria-haspopup="true" aria-expanded="false" tabindex="-1">
                                <i class="fa fa-spinner fa-spin" style="color: #545874;"></i>
                            </a>
                        </li> -->
                        <li class="m-menu__item m-menu__item--submenu" aria-haspopup="true"
                            style="display: table;width: 100%;" data-menu-submenu-toggle="hover" role="none">
                            <a href="javascript:;" class="m-menu__link m-menu__toggle" role="menuitem"
                                aria-haspopup="true" aria-expanded="false" tabindex="-1">
                                <span class="m-menu__link-text">
                                    <span class="title">
                                        <ngx-skeleton-loader
                                            [theme]="{height: '10px', 'margin-bottom': '0'}"></ngx-skeleton-loader>
                                    </span>
                                </span>
                            </a>
                        </li>
                        <li class="m-menu__item m-menu__item--submenu" aria-haspopup="true"
                            style="display: table;width: 100%;" data-menu-submenu-toggle="hover" role="none">
                            <a href="javascript:;" class="m-menu__link m-menu__toggle" role="menuitem"
                                aria-haspopup="true" aria-expanded="false" tabindex="-1">
                                <span class="m-menu__link-text">
                                    <span class="title">
                                        <ngx-skeleton-loader
                                            [theme]="{height: '10px', 'margin-bottom': '0'}"></ngx-skeleton-loader>
                                    </span>
                                </span>
                            </a>
                        </li>
                        <li class="m-menu__item m-menu__item--submenu" aria-haspopup="true"
                            style="display: table;width: 100%;" data-menu-submenu-toggle="hover" role="none">
                            <a href="javascript:;" class="m-menu__link m-menu__toggle" role="menuitem"
                                aria-haspopup="true" aria-expanded="false" tabindex="-1">
                                <span class="m-menu__link-text">
                                    <span class="title">
                                        <ngx-skeleton-loader
                                            [theme]="{height: '10px', 'margin-bottom': '0'}"></ngx-skeleton-loader>
                                    </span>
                                </span>
                            </a>
                        </li>
                        <li class="m-menu__item m-menu__item--submenu" aria-haspopup="true"
                            style="display: table;width: 100%;" data-menu-submenu-toggle="hover" role="none">
                            <a href="javascript:;" class="m-menu__link m-menu__toggle" role="menuitem"
                                aria-haspopup="true" aria-expanded="false" tabindex="-1">
                                <span class="m-menu__link-text">
                                    <span class="title">
                                        <ngx-skeleton-loader
                                            [theme]="{height: '10px', 'margin-bottom': '0'}"></ngx-skeleton-loader>
                                    </span>
                                </span>
                            </a>
                        </li>
                    </ng-template>
                </ul>
            </nav>
        </li>
        <li routerLinkActive="m-menu__item--active" [routerLinkActiveOptions]="{exact: true}"
            class="m-menu__item m-menu__item--submenu" aria-haspopup="true" data-menu-submenu-toggle="hover"
            usetiful_id="sidebar__settings-button--primary">

            <a [routerLink]="'/app/main/settings'" class="m-menu__link m-menu__toggle" role="menuitem"
                aria-haspopup="true" aria-expanded="false" [attr.tabindex]="0">
                <i class="m-menu__link-icon flaticon-settings"></i>
                <span class="m-menu__link-text">
                    <span class="title">Settings</span>
                </span>
            </a>
        </li>

        <ng-container>
            <ng-template ngFor let-menuItem [ngForOf]="menu.items" let-mainMenuItemIndex="index">
                <li *ngIf="showMenuItem(menuItem)" class="m-menu__item m-menu__item--submenu"
                    [ngClass]="{'m-menu__item--expanded m-menu__item--open': menuItem.items.length >  0}"
                    aria-haspopup="true" data-menu-submenu-toggle="hover">

                    <a [routerLink]="[menuItem.route]" *ngIf="!menuItem.items.length && !menuItem.external"
                        class="m-menu__link m-menu__toggle" role="menuitem" aria-haspopup="true" aria-expanded="false"
                        [attr.tabindex]="mainMenuItemIndex == 0 ? 0 : -1">
                        <i class="m-menu__link-icon {{menuItem.icon}}"></i>
                        <span class="m-menu__link-text">
                            <span class="title">{{l(menuItem.name)}}</span>
                        </span>
                    </a>

                    <a [attr.href]="[menuItem.route]" *ngIf="!menuItem.items.length && menuItem.external"
                        class="m-menu__link m-menu__toggle" target="_blank" role="menuitem" aria-haspopup="true"
                        aria-expanded="false" [attr.tabindex]="mainMenuItemIndex == 0 ? 0 : -1">
                        <i class="m-menu__link-icon {{menuItem.icon}}"></i>
                        <span class="m-menu__link-text">
                            <span class="title">{{l(menuItem.name)}}</span>
                        </span>
                    </a>

                    <a href="javascript:;" *ngIf="menuItem.items.length" class="m-menu__link m-menu__toggle"
                        role="menuitem" aria-haspopup="true" aria-expanded="false"
                        [attr.tabindex]="mainMenuItemIndex == 0 ? 0 : -1">
                        <i class="m-menu__link-icon {{menuItem.icon}}"></i>
                        <span class="m-menu__link-text">
                            <span class="title">{{l(menuItem.name)}}</span>
                        </span>
                        <i class="m-menu__ver-arrow la la-angle-right"></i>
                    </a>
                    <nav class="m-menu__submenu" *ngIf="menuItem.items.length" [attr.aria-label]="l(menuItem.name)">
                        <span class="m-menu__arrow"></span>
                        <ul class="m-menu__subnav" [attr.aria-label]="l(menuItem.name)" role="menu">
                            <ng-template ngFor let-childMenuItem [ngForOf]="menuItem.items"
                                let-mainMenuItemIndex="index">
                                <li *ngIf="showMenuItem(childMenuItem)" routerLinkActive="m-menu__item--active"
                                    [routerLinkActiveOptions]="{exact: true}" class="m-menu__item m-menu__item--submenu"
                                    aria-haspopup="true" data-menu-submenu-toggle="hover" role="none">
                                    <a [routerLink]="[childMenuItem.route]"
                                        *ngIf="!childMenuItem.items.length && !childMenuItem.external"
                                        class="m-menu__link m-menu__toggle" role="menuitem" aria-haspopup="true"
                                        aria-expanded="false" tabindex="-1">
                                        <i class="m-menu__link-icon {{childMenuItem.icon}}"></i>
                                        <span class="m-menu__link-text">
                                            <span class="title">{{l(childMenuItem.name)}}</span>
                                        </span>
                                    </a>
                                    <a [attr.href]="[childMenuItem.route]"
                                        *ngIf="!childMenuItem.items.length && childMenuItem.external"
                                        class="m-menu__link m-menu__toggle" target="_blank" role="menuitem"
                                        aria-haspopup="true" aria-expanded="false" tabindex="-1">
                                        <i class="m-menu__link-icon {{childMenuItem.icon}}"></i>
                                        <span class="m-menu__link-text">
                                            <span class="title">{{l(childMenuItem.name)}}</span>
                                        </span>
                                    </a>
                                    <a href="javascript:;" class="m-menu__link m-menu__toggle"
                                        *ngIf="childMenuItem.items.length" role="menuitem" aria-haspopup="true"
                                        aria-expanded="false" tabindex="-1">
                                        <i class="m-menu__link-icon {{childMenuItem.icon}}"></i>
                                        <span class="m-menu__link-text">
                                            <span class="title">{{l(childMenuItem.name)}}</span>
                                        </span>
                                        <i class="m-menu__ver-arrow la la-angle-right"></i>
                                    </a>
                                    <nav class="m-menu__submenu" *ngIf="childMenuItem.items.length"
                                        [attr.aria-label]="l(menuItem.name)">
                                        <span class="m-menu__arrow"></span>
                                        <ul class="m-menu__subnav" [attr.aria-label]="l(menuItem.name)" role="menu">
                                            <!-- Menu Level 3 -->
                                            <ng-template ngFor let-childOfChildMenuItem [ngForOf]="childMenuItem.items"
                                                let-childOfChildMenuItemIndex="index">
                                                <li *ngIf="showMenuItem(childOfChildMenuItem)"
                                                    routerLinkActive="m-menu__item--active "
                                                    [routerLinkActiveOptions]="{exact: true}"
                                                    class="m-menu__item m-menu__item--submenu" aria-haspopup="true"
                                                    role="none" data-menu-submenu-toggle="hover">
                                                    <a [routerLink]="[childOfChildMenuItem.route]"
                                                        *ngIf="!childOfChildMenuItem.items.length && !childOfChildMenuItem.external"
                                                        class="m-menu__link m-menu__toggle" role="menuitem"
                                                        aria-haspopup="true" aria-expanded="false" tabindex="-1">
                                                        <i class="m-menu__link-icon {{childOfChildMenuItem.icon}}"></i>
                                                        <span class="m-menu__link-text">
                                                            <span class="title">{{l(childOfChildMenuItem.name)}}</span>
                                                        </span>
                                                    </a>
                                                    <a [attr.href]="[childOfChildMenuItem.route]"
                                                        *ngIf="!childOfChildMenuItem.items.length && childOfChildMenuItem.external"
                                                        class="m-menu__link m-menu__toggle" target="_blank"
                                                        role="menuitem" aria-haspopup="true" aria-expanded="false"
                                                        tabindex="-1">
                                                        <i class="m-menu__link-icon {{childOfChildMenuItem.icon}}"></i>
                                                        <span class="m-menu__link-text">
                                                            <span class="title">{{l(childOfChildMenuItem.name)}}</span>
                                                        </span>
                                                    </a>
                                                    <a href="javascript:;" class="m-menu__link m-menu__toggle"
                                                        *ngIf="childOfChildMenuItem.items.length" role="menuitem"
                                                        aria-haspopup="true" aria-expanded="false" tabindex="-1">
                                                        <i class="m-menu__link-icon {{childOfChildMenuItem.icon}}"></i>
                                                        <span class="m-menu__link-text">
                                                            <span class="title">{{l(childOfChildMenuItem.name)}}</span>
                                                        </span>
                                                        <i class="m-menu__ver-arrow la la-angle-right"></i>
                                                    </a>
                                                    <nav class="m-menu__submenu"
                                                        *ngIf="childOfChildMenuItem.items.length"
                                                        [attr.aria-label]="l(menuItem.name)">
                                                        <span class="m-menu__arrow"></span>
                                                        <ul class="m-menu__subnav" [attr.aria-label]="l(menuItem.name)"
                                                            role="menu">
                                                            <!-- Menu Level 4 -->
                                                            <ng-template ngFor let-childOfChildOfChildMenuItem
                                                                [ngForOf]="childOfChildMenuItem.items"
                                                                let-childOfChildMenuItemIndex="index">
                                                                <li *ngIf="showMenuItem(childOfChildOfChildMenuItem)"
                                                                    routerLinkActive="m-menu__item--active "
                                                                    [routerLinkActiveOptions]="{exact: true}"
                                                                    class="m-menu__item m-menu__item--submenu"
                                                                    role="none">
                                                                    <a [routerLink]="[childOfChildOfChildMenuItem.route]"
                                                                        *ngIf="!childOfChildOfChildMenuItem.external"
                                                                        class="m-menu__link" role="menuitem"
                                                                        aria-haspopup="true" aria-expanded="false"
                                                                        tabindex="-1">
                                                                        <i
                                                                            class="m-menu__link-icon {{childOfChildOfChildMenuItem.icon}}"></i>
                                                                        <span class="m-menu__link-text">
                                                                            <span
                                                                                class="title">{{l(childOfChildOfChildMenuItem.name)}}</span>
                                                                        </span>
                                                                    </a>
                                                                    <a [attr.href]="[childOfChildOfChildMenuItem.route]"
                                                                        *ngIf="childOfChildOfChildMenuItem.external"
                                                                        class="m-menu__link" target="_blank"
                                                                        role="menuitem" aria-haspopup="true"
                                                                        aria-expanded="false" tabindex="-1">
                                                                        <i
                                                                            class="m-menu__link-icon {{childOfChildOfChildMenuItem.icon}}"></i>
                                                                        <span class="m-menu__link-text">
                                                                            <span
                                                                                class="title">{{l(childOfChildOfChildMenuItem.name)}}</span>
                                                                        </span>
                                                                    </a>
                                                                </li>
                                                            </ng-template>
                                                        </ul>
                                                    </nav>
                                                </li>
                                            </ng-template>
                                        </ul>
                                    </nav>
                                </li>
                            </ng-template>
                        </ul>
                    </nav>
                </li>
            </ng-template>
        </ng-container>
    </ul>
</nav>
<div id="ListSubscriptionExpiredModel" class="modal fade" tabindex="-1" role="dialog" style="display:none">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div *ngIf="hasPlanExpired" class="modal-header">
                <h5>{{expiredPlanHeadingText}}</h5>
            </div>
            <div *ngIf="!hasPlanExpired" class="modal-header">
                <h5>{{expiredPlanHeadingText}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <p class="popup-body-font"><label>{{expiredPlanBodyText}}</label></p>
            </div>

            <div *ngIf="hasPlanExpired" class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="extendTrialPeriod()"
                    *ngIf="planExtendedCount < 2" [disabled]="isLoaderForExtendPlan">
                    Extend Free Trial <i *ngIf="isLoaderForExtendPlan" class="fa fa-spinner fa-spin"></i>
                </button>
                <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="GoToPricing()">
                    Go to
                    Pricing
                </button>
            </div>
            <div *ngIf="!hasPlanExpired" class="modal-footer">

                <button type="button" class="btn btn-primary btn-gotopricing" data-dismiss="modal"
                    (click)="GoToPricing()">
                    Go to
                    Pricing
                </button>
                <button type="button" style="display:none;" class="btn btn-primary btn-upgrade" data-dismiss="modal"
                    (click)="SetUpgradeLink()">Upgrade</button>
                <button type="button" class="btn btn-secondary expiry" data-dismiss="modal">
                    OK
                </button>
            </div>
        </div>
    </div>
</div>